import React from 'react';

/**
 * Klickbarer Tabellenkopf für rein clientseitige, plain-Bootstrap-`<Table>`-
 * Listen (siehe B2bRunDetail.jsx / B2cRunDetail.jsx) - kein Ersatz für
 * DataGrid/@tanstack-react-table, nur ein schlanker Header mit Sortier-
 * Indikator für Seiten, die keine volle Tabellen-Komponente brauchen.
 *
 * @param {{key: string, label: string}} column
 * @param {string|null} sortKey - aktuell aktive Sortier-Spalte
 * @param {'asc'|'desc'} sortDir
 * @param {(key: string) => void} onSort
 */
export default function SortableTh({column, sortKey, sortDir, onSort}) {
    const isActive = sortKey === column.key;
    return (
        <th
            role="button"
            onClick={() => onSort(column.key)}
            style={{cursor: 'pointer'}}
            className={isActive ? 'text-decoration-underline' : undefined}
        >
            {column.label}
            <span className="ms-1 text-muted">
                {isActive ? (sortDir === 'asc' ? '▲' : '▼') : ''}
            </span>
        </th>
    );
}
